import { useI18n } from '@i18n/I18nProvider'
import { BottomSheet } from '@ui/BottomSheet'
import { ErrorState, LoadingState } from '@ui/States'
import { SpeciesDetails } from './SpeciesDetails'
import { useSpecies } from './useSpecies'

// La ficha de una especie en una hoja, sin salir de donde se está (el mapa o la ficha de un
// árbol). Abre por la pestaña de la comunidad del árbol.
export const SpeciesSheet = ({
	id,
	regionId,
	onClose,
}: {
	id: string
	regionId: string | null
	onClose: () => void
}) => {
	const { t } = useI18n()
	const { data: species, error, isPending, refetch } = useSpecies(id)
	return (
		<BottomSheet title={species?.commonName ?? t('tree.aboutSpecies')} onClose={onClose}>
			{isPending ? (
				<LoadingState />
			) : error || !species ? (
				<ErrorState error={error} onRetry={() => refetch()} />
			) : (
				<SpeciesDetails species={species} wantedRegion={regionId} showName={false} />
			)}
		</BottomSheet>
	)
}
